import { useContext } from 'react';

import { ICodePipelineSettingData } from '@Type';
import { CodePipelineContext } from '../stores/provider';

const useCodePipeline = (): ICodePipelineSettingData | null => {
  return useContext(CodePipelineContext);
};
export default useCodePipeline;
